import styled, { css } from 'styled-components'

import { WorkspaceLogo as BaseWorkspaceLogo } from '@sketch/components'
import Panel from 'components/Panel'

const darkBoldText = css`
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
  font-size: 1rem;
  line-height: 1.4;
  font-weight: 500;
  margin: 0;
`

export const Card = styled(Panel)`
  background-color: ${({ theme }) => theme.colors.background.secondary.B};
  border: 1px solid ${({ theme }) => theme.colors.border.A};
  box-shadow: ${({ theme }) => theme.shadows.boxShadow.subtle};
`

export const WorkspaceLogo = styled(BaseWorkspaceLogo)`
  margin-right: 16px;
  background: ${({ theme }) => theme.colors.background.secondary.A};
`

export const WorkspaceName = styled.h1`
  ${darkBoldText}
`

export const CardItem = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 20px;

  & + & {
    border-top: 1px solid ${({ theme }) => theme.colors.border.A};
  }
`

export const Line = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`

export const Text = styled.p`
  margin: 0;

  color: ${({ theme }) => theme.colors.foreground.secondary.C};
  font-size: 0.8125rem;
  line-height: 1.4;

  & + & {
    margin-top: 3px; /* stylelint-disable-line scales/space  */
  }
`

export const TotalLine = styled(Line)`
  position: relative;
  padding-top: 8px;
  margin-top: 12px;

  :after {
    position: absolute;
    top: 0;
    right: 0;
    width: 33%;
    height: 1px;

    content: '';
    background-image: linear-gradient(to right, #d8d8d8 60%, #0000 0%);
    background-position: top;
    background-size: 8px 1px;
    background-repeat: repeat-x;
  }
`

export const TotalText = styled.p`
  ${darkBoldText}
`
